import "./TrialLessonPopup.scss";

const TrialLessonPopupModal = ({ isOpen, onClose, onCreate }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Create A Trial Lesson</h2>
        <p>
          Set up a 30 minute introductory session. This acts as your "front
          door," allowing you to assess student levels and build rapport before
          they commit to a full curriculum.
        </p>
        <div className="modal-actions">
          <button className="create-btn" onClick={onCreate}>
            + Create Trial Lesson
          </button>
          <button className="close-btn" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default TrialLessonPopupModal;
